// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"fN-z","carouselContainer":"gN-z"};